import { create } from "zustand"

interface ManualModeState {
  isActive: boolean
  speed: number
  strokeMin: number
  strokeMax: number
  setActive: (active: boolean) => void
  setSpeed: (speed: number) => void
  setStrokeRange: (min: number, max: number) => void
  reset: () => void
}

export const useManualModeStore = create<ManualModeState>((set) => ({
  isActive: false,
  speed: 50,
  strokeMin: 0,
  strokeMax: 100,
  setActive: (isActive) => set({ isActive }),
  setSpeed: (speed) => set({ speed }),
  setStrokeRange: (strokeMin, strokeMax) => set({ strokeMin, strokeMax }),
  reset: () => set({ isActive: false, speed: 50, strokeMin: 0, strokeMax: 100 }),
}))
